import React from 'react';
import Home from './views/Home';
import Sobre from './views/Sobre';
import Informacoes from './views/Informacoes';
import Vulnerabilidade from './views/Vulnerabilidade';
import Direitos from './views/Direitos';
import Equipe from './views/Equipe';
import Contato from './views/Contato';
import Busca from './views/Busca';
import Header from './components/Header';
import Footer from './components/Footer';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

function App() {
  return (
    <React.Fragment>
      <Router>
        <Header />
        <Switch>
          <Route path="/"                                             component={Home} exact />
          <Route path="/sobre"                                        component={Sobre} exact />
          <Route path="/busca"                                        component={Busca} exact />
          <Route path="/informacoes-importantes"                      component={Informacoes} exact />
          <Route path="/se-sente-vulneravel"                          component={Vulnerabilidade} exact />
          <Route path="/meus-direitos"                                component={Direitos} exact />
          <Route path="/equipe"                                       component={Equipe} exact />
          <Route path="/contato"                                      component={Contato} exact /> 
        </Switch>
        <Footer />
      </Router>
    </React.Fragment>
  );
}

export default App;
